import logo from './logo.svg';
import './App.css';
import DNav from './components/navs/regdnav'
import CFNavAndes from './components/navs/cfnavandes'
import CFNavTexture from './components/navs/cfnavtexture'
import HeroSM from './components/heroes/herosmimg'
import HeroLG from './components/heroes/herolgimg'
// import Disqus from './components/disqus'
import Intro from './components/intro'
import Why from './components/why'
import Summary from './components/summary'
import Mgmt from './components/mgmt'
import CTA from './components/cta'
import DFoot from './components/footers/dfoot'
import AndesFaq from './components/vendors/andes'
import TextureFaq from './components/vendors/texture'
import AndesFootCF from './components/footers/cffootandes'
import TextureFootCF from './components/footers/cffoottexture'
import Carousel from './components/carousel'
function App() {
  return (
    <div className="App">
      <DNav />
      <HeroLG />
      {/* <Carousel/> */}
      <Intro />
      <Why />
      <Summary />
      <Mgmt />
  
      {/* <TextureFaq/> */}
      <CTA />
<DFoot/>
      {/* <Disqus/> */}
    </div>
  );
}

export default App;
